var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYears(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5966",
    "data-name": "Group 5966",
    transform: "translate(10413 -5884)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_100",
    "data-name": "Ellipse 100",
    cx: 15,
    cy: 15,
    r: 15,
    transform: "translate(-10413 5884)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "clock_2_",
    "data-name": "clock(2)",
    d: "M10.222,0A10.222,10.222,0,1,0,20.445,10.222,10.234,10.234,0,0,0,10.222,0Zm4.862,15.51a.851.851,0,0,1-1.2,0L9.62,11.251a.848.848,0,0,1-.25-.6V5.111a.852.852,0,0,1,1.7,0V10.3l4.01,4.01a.851.851,0,0,1,0,1.2Zm0,0",
    transform: "translate(-10408 5889)",
    fill: "#3f2566"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYears);
export default __webpack_public_path__ + "static/media/Years.6599f7f7af72d53e41d4801bb68db195.svg";
export { ForwardRef as ReactComponent };